import { render, staticRenderFns } from "./planParticular.vue?vue&type=template&id=b973901c&scoped=true&"
import script from "./planParticular.vue?vue&type=script&lang=js&"
export * from "./planParticular.vue?vue&type=script&lang=js&"
import style0 from "./planParticular.vue?vue&type=style&index=0&id=b973901c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b973901c",
  null
  
)

export default component.exports